<div class="px-4 py-2 bg-gray-50">
  <div class="page-title">Bulk Add Users</div>

  <div class="grid grid-cols-1 lg:grid-cols-2 gap-x-4 mt-4">
    <div class="items-center w-full pb-4">
      <strong>Instructions</strong>
      <p>
        This page will allow Account Managers to bulk upload their users into PRISM. As soon as the accounts are created, the new users will receive an initial email from PRISM with a link to create a password, giving access to the account. 
      </p>
      <br>
      <strong>File Requirements</strong>
      <ul class="list-disc pl-5 mt-2">
        <li>Must be in XLSX format.</li>
        <li>To ensure data is properly imported you cannot manipulate the name of the tabs, order & name of the fields.</li>
        <li>
          Must be in specified file layout:
          <br />
          <b>firstName, lastName, emailName, districtId, schoolId, gradeId.</b>
        </li>
        <li>
         Click to
          <button
            type="button"
            (click)="onDownloadTemplate($event)"
            [class.pointer-events-none]="isDownloading"
            [class.opacity-50]="isDownloading"
            [attr.aria-disabled]="isDownloading"
            class="underline text-dark-purple font-medium bg-transparent border-0 cursor-pointer p-0"
          >
            download the required file layout
          </button>
        </li>
      </ul>
    </div>
  </div>

  <div class="mt-4 flex flex-col sm:flex-row gap-4">
    <div class="file-btn-wrapper">
      <prism-btn btnType="button"
        btnClass="bg-white text-dark-purple font-bold border-2 p-2 rounded-xl border-dark-purple w-full sm:w-auto"
        (click)="fileInput.click()">
        Choose File
      </prism-btn>
      <input #fileInput type="file" id="userUpload" class="hidden" (change)="addFile($event)"
        accept=".csv, .xlsx, .xls" />
    </div>

    @if (tableData && tableData.length && !canUpload) {
    <prism-btn btnType="button"
      btnClass="bg-dark-purple text-white font-bold border-2 p-2 rounded-xl border-dark-purple w-full sm:w-auto"
      (click)="validate()">
      Validate
    </prism-btn>
    }

    @if (canUpload) {
    <prism-btn btnType="button"
      btnClass="bg-dark-purple text-white font-bold border-2 p-2 rounded-xl border-dark-purple w-full sm:w-auto"
      (click)="upload()">
      Upload
    </prism-btn>
    }
  </div>

  <div class="results mt-5">
    <div class="overflow-x-auto pb-4">
      <table class="w-full min-w-max upload-table">
        <thead>
          <tr>
            <th *ngFor="let header of headers" class="text-start py-2 px-2 sm:px-4 md:px-6">
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let row of tableData; let i = index">
            <tr class="cursor-pointer" (click)="edit(row)"
              >
              <ng-container *ngFor="let col of row">
                <td class="pt-5 px-2 sm:px-4 md:px-6">
                  <span *ngIf="!row.edit" [ngClass]="{ 'invalid-data': col.invalid }" class="font-semibold">
                    {{ col.value }}
                    <span *ngIf="!col.displayValue || col.invalid" class="text-red">**</span>
                  </span>
                 <input *ngIf="row.edit" class="form-control pl-2 mt-2 p-1" maxlength="50"
                  [ngClass]="{ 'text-red': col.invalid }" type="text"
                  [(ngModel)]="col.value"
                  (ngModelChange)="col.displayValue = col.value" />
                </td>
              </ng-container>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>